import type { RegisteredServices } from '@/core/container/types'

export const FormClickToTextTableId = 'FormClickToTextTableId' as RegisteredServices

export const FormSubscribeTableId = 'FormSubscribeTableId' as RegisteredServices
